"use client";
import { jsx as l, jsxs as i, Fragment as y } from "react/jsx-runtime";
import f, { createContext as v, useContext as p, useState as N } from "react";
import { classNames as c } from "../../utilities/index.js";
import h from "../Image/index.js";
import I from "../VideoModal/index.js";
import V from "../Icon/index.js";
const m = v(null), d = ({ variant: e, className: t, children: n, horizontal: r, ...a }) => {
  const s = c({
    "sash-Card flex relative bg-white h-full transition-shadow [&:has(a)]:hover:shadow-lg": !0,
    "p-4": !r && !e,
    "sash-Card--padded": e === "standard-padded-content",
    "sash-Card--full text-center": e === "standard-full",
    "sash-Card--award p-4 md:p-6": e === "award",
    "sash-Card--horizontal flex-row": r,
    "flex-col border border-gray-15": !r,
    [t]: t
  });
  return /* @__PURE__ */ l(m.Provider, { value: { variant: e, horizontal: r }, children: /* @__PURE__ */ l(
    "div",
    {
      className: s,
      ...a,
      children: n
    }
  ) });
}, C = ({ src: e, className: t, children: n, ...r }) => {
  const a = p(m), s = c({
    "sash-CardImage !block": !0,
    "w-full": a.variant !== "award",
    "h-[180px] mx-auto": a.variant === "award",
    "flex-1 !max-w-6/12 h-full": a.horizontal,
    "mb-4": !a.horizontal,
    [t]: t
  });
  return !e && !n ? null : /* @__PURE__ */ i(y, { children: [
    e && /* @__PURE__ */ l(
      h,
      {
        src: e,
        className: s,
        aspectRatio: a.variant !== "award" ? "4/3" : "",
        objectFit: a.variant === "award" ? "contain" : "cover",
        alt: "",
        ...r
      }
    ),
    !e && n && f.Children.map(
      n,
      (o) => f.cloneElement(o, {
        className: s,
        style: { aspectRatio: a.variant !== "award" ? "4/3" : "", objectFit: a.variant === "award" ? "contain" : "cover" }
      })
    )
  ] });
}, b = ({ imageSrc: e, videoData: t, className: n, ...r }) => {
  var x, u;
  const [a, s] = N(!1);
  if (!(t != null && t.id))
    return null;
  const o = () => s(!a);
  return /* @__PURE__ */ i(
    "div",
    {
      className: `sash-CardVideo mb-4 ${n || ""}`,
      ...r,
      children: [
        /* @__PURE__ */ i(
          "button",
          {
            "aria-label": "Play Video",
            className: "sash-CardVideo-Trigger relative w-full",
            onClick: o,
            children: [
              /* @__PURE__ */ l(
                h,
                {
                  src: e,
                  aspectRatio: "16/9",
                  objectFit: "cover",
                  className: "block w-full",
                  alt: ""
                }
              ),
              /* @__PURE__ */ l("span", { className: "sash-CardVideo-PlayIcon absolute left-1/2 top-1/2 flex h-[84px] w-[84px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-3 border-white bg-primary xl:h-[100px] xl:w-[100px]", children: /* @__PURE__ */ l(
                V,
                {
                  name: "play_arrow",
                  className: "block !text-5xl text-black xl:!text-6xl"
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ l(
          I,
          {
            isOpen: a,
            videoId: (x = t.id) != null && x.includes("mp4") ? null : t.id,
            title: t.title,
            transcript: t.transcript,
            internal: (u = t.id) != null && u.includes("mp4") ? t.id : null,
            onClose: o,
            className: "sash-CardVideo-Modal"
          }
        )
      ]
    }
  );
}, g = ({ content: e, className: t, ...n }) => {
  const r = p(m), a = c({
    "sash-CardHeading font-semibold [&>*>span]:block [&>*>span]:mb-0.5 [&>*>span]:uppercase [&>*>span]:text-xs md:[&>*>span]:text-sm [&>*>span]:tracking-widest [&>*>span]:font-normal": !0,
    "md:text-xl": !r.variant,
    "text-base md:text-lg !leading-tight mb-2": r.variant === "award",
    "px-6 pb-4 text-lg md:text-xl": r.variant === "standard-padded-content",
    "px-6 text-2xl": r.variant === "standard-full",
    [t]: t
  });
  return !e || r.horizontal ? null : /* @__PURE__ */ l(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: e },
      ...n
    }
  );
}, w = ({ content: e, className: t, children: n, ...r }) => {
  const a = p(m), s = c({
    "sash-CardContent": !0,
    "mt-2": !a.horizontal && !a.variant,
    "px-6 pb-6": !a.horizontal && a.variant === "standard-padded-content",
    "px-6 mt-2 text-xs pb-2 md:pb-6": !a.horizontal && a.variant === "standard-full",
    "flex-1 flex flex-col h-full justify-center items-start border border-gray-15 text-base xl:text-xl font-semibold py-6 px-4 md:py-10 md:px-6 [&_a]:decoration-primary": a.horizontal,
    [t]: t
  });
  return /* @__PURE__ */ i(
    "div",
    {
      className: s,
      ...r,
      children: [
        e && /* @__PURE__ */ l("div", { dangerouslySetInnerHTML: { __html: e } }),
        n
      ]
    }
  );
};
d.Image = C;
d.Video = b;
d.Heading = g;
d.Content = w;
C.displayName = "Card.Image";
b.displayName = "Card.Video";
g.displayName = "Card.Heading";
w.displayName = "Card.Content";
const M = d;
export {
  M as default
};
